import {
    LOGOUT,
    O365_REGISTER_REQUEST,
    O365_REGISTER_SUCCESS,
    O365_REGISTER_FAILURE,

    BSRS_LOGIN_REQUEST,
    BSRS_LOGIN_SUCCESS,
    BSRS_LOGIN_FAILURE,

    CORE_USER_INTEGRATION_REQUEST,
    CORE_USER_INTEGRATION_SUCCESS,
    CORE_USER_INTEGRATION_FAILURE,

    CORE_FORGOT_PASSWORD_REQUEST,
    CORE_FORGOT_PASSWORD_SUCCESS,
    CORE_FORGOT_PASSWORD_FAILURE,

    CORE_CONFIRM_RESET_PASSWORD_REQUEST,
    CORE_CONFIRM_RESET_PASSWORD_SUCCESS,
    CORE_CONFIRM_RESET_PASSWORD_FAILURE,

    CORE_LOGOUT_REQUEST,
    CORE_LOGOUT_SUCCESS,
    CORE_LOGOUT_FAILURE,

    CORE_USER_AUTHEN_O365_REQUEST,
    CORE_USER_AUTHEN_O365_SUCCESS,
    CORE_USER_AUTHEN_O365_FAILURE,

} from '../../types'

import { getIsRemember, setToken, clearBSRSToken, setBSRSToken, CORE_API_ENDPOINT, getTargetUrl, deleteTargetUrl } from 'Lib'
import { CALL_API } from 'Middlewares'

export function authorizeO365(code) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/integration`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ code }),
            types: [
                O365_REGISTER_REQUEST,
                {
                    type: O365_REGISTER_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {

                                const {
                                    access_token,
                                    expires_on,
                                    refresh_token
                                } = json.value

                                const token = {
                                    access_token,
                                    expires_on,
                                    refresh_token
                                }

                                setToken(token)
                                return { token }
                            })
                    },
                    callback() {
                        window.location.replace('/integrationInfo')
                    }
                },
                O365_REGISTER_FAILURE
            ]
        }
    }
}

export function signinWithO365(code) {
    let data
    const isRemember = getIsRemember() === 'true' || getIsRemember() === true ? true : false
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/web/o365/verify`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ code }),
            types: [
                CORE_USER_AUTHEN_O365_REQUEST,
                {
                    type: CORE_USER_AUTHEN_O365_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {
                                const {
                                    isIntegration,
                                    token,
                                    expires_on,
                                    user,
                                    system_key,
                                    role,
                                } = json.value

                                data = json.value

                                let bsrsToken = createCookie(
                                    user,
                                    isIntegration,
                                    false,
                                    token,
                                    expires_on,
                                    system_key,
                                    isRemember,
                                    role
                                )

                                return { bsrsToken }
                            })
                    },
                    callBack() {
                        if (data.user.isFirstLogin)
                            window.location.replace(`/changeInformation/${data.user._id}?email=${data.user.email}`)
                        else {
                            const target = getTargetUrl()
                            if (target) {
                                window.location.replace(target)
                                deleteTargetUrl()
                            } else {
                                window.location.replace("/")
                            }
                        }
                    }
                },
                CORE_USER_AUTHEN_O365_FAILURE
            ]
        }
    }
}

export function insertUserIntegration(code) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/integration/o365`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ code }),
            types: [
                CORE_USER_INTEGRATION_REQUEST,
                {
                    type: CORE_USER_INTEGRATION_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {
                                const {
                                    // access_token,
                                    expires_on,
                                    refresh_token,
                                    user,
                                    token,
                                    role
                                } = json.value

                                let bsrsToken = createCookie(user,
                                    true,
                                    false,
                                    token,
                                    expires_on,
                                    "o365",
                                    false,
                                    role)

                                return { bsrsToken }
                            })
                    },
                    callBack() {
                        clearBSRSToken()
                        window.location.replace('/')
                    }
                },
                CORE_USER_INTEGRATION_FAILURE
            ]
        }
    }
}

export function authorizeBSRS({ email, password }, isRemember) {
    let data
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/verify`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email, password }),
            types: [
                BSRS_LOGIN_REQUEST,
                {
                    type: BSRS_LOGIN_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {
                                const {
                                    isIntegration,
                                    isUserActiveDirectory,
                                    token,
                                    expires_on,
                                    user,
                                    system_key,
                                    role,
                                } = json.value

                                data = json.value

                                let bsrsToken = createCookie(user,
                                    isIntegration,
                                    isUserActiveDirectory,
                                    token,
                                    expires_on,
                                    system_key,
                                    isRemember,
                                    role
                                )

                                return { bsrsToken }
                            })
                    },
                    callBack() {
                        try {
                            if (data.user.isFirstLogin)
                                window.location.replace(`/changeInformation/${data.user._id}?email=${data.user.email}`)
                            else {
                                const target = getTargetUrl()
                                if (target) {
                                    window.location.replace(target)
                                    deleteTargetUrl()
                                } else {
                                    window.location.replace("/")
                                }
                            }
                        } catch (error) {
                            window.location.replace("/")
                        }
                    }
                },
                BSRS_LOGIN_FAILURE
            ]
        }
    }
}

export const sendMailForgotPassword = (email, url) => {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/resetpassword`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, url }),
            types: [
                CORE_FORGOT_PASSWORD_REQUEST,
                {
                    type: CORE_FORGOT_PASSWORD_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return json.value
                            })
                    },
                    callBack() {
                        // history.push(`/events/success/update`)
                    }
                },
                CORE_FORGOT_PASSWORD_FAILURE
            ]
        }
    }
}

export const sendMailResetPassword = (key) => {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/confirmresetpassword/${key}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_CONFIRM_RESET_PASSWORD_REQUEST,
                {
                    type: CORE_CONFIRM_RESET_PASSWORD_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return json.value
                            })
                    },
                },
                CORE_CONFIRM_RESET_PASSWORD_FAILURE
            ]
        }
    }
}

export function logout() {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/logout`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_LOGOUT_REQUEST,
                {
                    type: CORE_LOGOUT_SUCCESS,
                    callBack() {
                        clearBSRSToken()
                        window.location.replace('/login')
                    }
                },
                CORE_LOGOUT_FAILURE
            ]
        }
    }
}


function createCookie(user, isIntegration, isUserActiveDirectory = false, token, expires_on, system_key, isRemember, role) {
    clearBSRSToken()
    const { id, _id, timeZone, firstName, lastName, email, lastLoginTime, status } = user
    let o365_token = null,
        o365_token_expire_on = null,
        integrationService = null
    if (user.token) {
        user.token.forEach(token => {
            const { data, service } = token
            if (data) {
                const { access_token, expires_on } = data
                o365_token = access_token
                o365_token_expire_on = expires_on
            }
            integrationService = service
        })
    }
    let setMaximumBookingMinutes = 300,
        setMaxAdvanceBookingDay = 30
    if (role && Object.keys(role).length > 0) {
        const { maximumBookingMinutes, maxAdvanceBookingDay } = role
        if (maximumBookingMinutes && typeof maximumBookingMinutes === 'number') {
            setMaximumBookingMinutes = maximumBookingMinutes
        }
        if (maxAdvanceBookingDay && typeof maxAdvanceBookingDay === 'number') {
            setMaxAdvanceBookingDay = maxAdvanceBookingDay
        }
    }
    let isAutoLock = false
    if (status && typeof status === 'string' && status.toUpperCase() === 'LOCK') {
        isAutoLock = true
    }
    let bsrsToken = {
        isIntegration: user.isIntegration,
        token,
        id: id ? id : _id ? _id : "",
        o365_token,
        o365_token_expire_on,
        email: email,
        timeZone,
        isUserActiveDirectory,
        firstName,
        lastName,
        lastLoginTime,
        service: system_key ? system_key : integrationService ? integrationService : "o365",//integrationService ? integrationService : system_key,
        token_expire: expires_on,
        isRemember,
        maxAdvanceBookingDay: setMaxAdvanceBookingDay,
        maximumBookingMinutes: setMaximumBookingMinutes,
        isAutoLock: isAutoLock
    }
    setBSRSToken(bsrsToken)
    return bsrsToken
}


// WEBPACK FOOTER //
// ./src/features/auth/actions.js